<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>アナウンス新規作成</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info" v-on:click="back">キャンセルする</button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <form @submit.prevent="register">
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>内容</label>
              </div>
              <div class="col-9">
                <textarea id="limited" v-model="announce" class="textarea" placeholder="アナウンス内容" rows="3" cols="60"></textarea>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>通知開始日時</label>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <input type="date" class="form-control" v-model="startDate" :min="now">
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <input type="time" class="form-control" v-model="startTime">
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>通知終了日時</label>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <input type="date" class="form-control" v-model="endDate"  :min="now">
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <input type="time" class="form-control" v-model="endTime">
                </div>
              </div>
            </div>
          </div>
          <div clas="form-group">
            <div class="row">
              <div class="col-3">
                <label>対象</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="type">
                  <option value=""></option>
                  <option value="1">{{allTenant}}</option>
                  <option value="2">{{selectTenant}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group" v-if="isSelectHospitals">
            <div class="row">
              <div class="col-3">
                <button type="button" class="btn btn-sm btn-outline-primary" v-on:click="openModal">追加する</button>
              </div>
              <div class="col-9">
                <table class="table table-sm table-hover form-table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th scope="col" style="width:80px"></th>
                      <th scope="col">Code</th>
                      <th scope="col">名称</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="target in targets" v-bind:key="target.hospitalId">
                      <td>
                        <button type="button" class="btn-sm" v-on:click="remove(target.hospitalId)">
                          <img class="times-solid" src="/times-solid.svg">
                        </button>
                      </td>
                      <td>{{ target.hospital.hospitalCode }}</td>
                      <td>{{ target.hospital.hospitalName }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <button id="register_button" type="submit" class="btn btn-info btn btn-block">登録する</button>
        </form>
      </div>
    </div>
    <HospitalModal v-show="showContent" v-on:close-modal="closeModal" v-on:add-target="addTarget($event)" v-bind:targets="targets" v-bind:parentName="name" v-bind:exclusionId="announceId" v-bind:realms="realms"/>
  </div>
</template>

<script>
import axios from 'axios'
import HospitalModal from './../../components/HospitalModal'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Create',
  mixins: [sessions,path,headers],
  props: ['realms','serviceName'],
  components: {
    HospitalModal
  },
  data: function(){
    return {
      name: 'announce',
      message: '',
      announce: '',
      type: '',
      startAt: '',
      endAt: '',
      startDate: '',
      startTime: '',
      endDate: '',
      endTime: '',
      now: new Date().toISOString().split('T')[0],
      targets: [],
      announceId: -1,
      showContent: false
    }
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    },
    isSelectHospitals: function () {
      return this.type == 2
    },
    allTenant:function (){
      return this.serviceName === 'SmartPhone' ? '全ての事業所' : '全ての病院'
    },
    selectTenant:function (){
      return this.serviceName === 'SmartPhone' ? '事業所を選択する' : '病院を選択する'
    },
  },
  methods: {
    remove(id) {
      var index = this.targets.findIndex((element) => element.hospitalId === id)
      this.targets.splice(index,1)
    },
    register() {
      var startAt = this.startDate + ' ' + this.startTime
      var endAt = this.endDate + ' ' + this.endTime
      if (!this.type) {
        this.message = "対象が選択されていません"
        return
      }
      if (!this.startDate || !this.startTime) {
        this.message = "通知開始日時が入力されていません"
        return
      }
      if (!this.endDate || !this.endTime) {
        this.message = "通知終了日時が入力されていません"
        return
      }
      if (startAt > endAt) {
        this.message = "通知終了日時を変更してください"
        return
      }
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var startAt = this.startDate + ' ' + this.startTime
          var endAt = this.endDate + ' ' + this.endTime
          var url = this.type == 1 ? "/api/announce/management/all" : "/api/announce/management/select"
          axios
            .post(url, {
            announce: this.announce,
            type: this.type,
            startAt: startAt,
            endAt: endAt,
            startDate: this.startDate,
            endDate: this.endDate,
            targets: this.targets,
          },{
            headers: this.headers(accessToken)
          }).then((response) => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage;
            } else {
              alert('登録されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/announce/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch(err => {
        this.message = err.message
      })
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/announce/index'))
    },
    openModal: function(){
      this.showContent = true
    },
    closeModal(){
      this.showContent = false
    },
    addTarget(event){
      this.targets = event
      this.closeModal()
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#backBtn {
  float:right;
}
#register_button {
  margin-top: 30px;
}
.times-solid{
  cursor: pointer;
  height: 15px;
  width: 15px;
}
.form-table{
  margin-top: 5px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>